import qs from 'qs';
import client from './client';

const taxBillUrl = '/api/v1/project/invoice';
 
//매출/매입 세금계산서 발행 초기 데이터 생성   
export const getInvoiceCrt = (id) => {
 // const queryString = qs.stringify(searchData);
  return client.get(`${taxBillUrl}/inf/${id}/list/create`);
};

//매출/매입 세금계산서 발행 개요 로딩 
export const getInvoiceInfList = (prjUuid, roUuid) => {
//  alert('bbb' + roUuid);
    return client.get(`${taxBillUrl}/inf/${prjUuid}/list/${roUuid}`);
 };

 export const getInvoiceInvDataList = (prjUuid, roUuid) => {
  //  alert('bbb' + roUuid);
      return client.get(`${taxBillUrl}/inv/${prjUuid}/list/${roUuid}`);
   };
  
 // 발주서 내역별 업체  세금계산서 발행 로딩 
 export const getInvoiceInvList = (prjUUid,roUuid,partnerUuid) => {
  // const queryString = qs.stringify(searchData);
   return client.get(`${taxBillUrl}/inv/${prjUUid}/po/${roUuid}/partner/${partnerUuid}`);
 };



// 채권/채무 수금
export const onCollectBuyPay = (dataToSubmit) => {
  return client.put(`${taxBillUrl}/info/${dataToSubmit.invUuid}`, dataToSubmit);
};

//수금/지급 취소
export const onCollectBuyCancle = (invId) => {
  return client.put(`${taxBillUrl}/info/${invId}`, { procCompYn: 'N' });
};
// 결재별 개요 가져오기(trjId, invTyp을 S로 고정함. )
export const getIssuedTaxbillsByApproval = (trjId) => {
  return client.get(`${taxBillUrl}/tran/${trjId}/S/single`);
};

//결재별 세금계산서 내역
export const getIssuedBuyTaxbillsByApproval = (trjId) => {
  return client.get(`${taxBillUrl}/tran/${trjId}/B`);
};

export const getIssuedSalesTaxbillsByApproval = (trjId) => {
  return client.get(`${taxBillUrl}/tran/${trjId}/S`);
};

//프로젝트별 세금계산서 init (S:매출, B:매입)
export const getInitTaxbillByPrj = (prjId, type) => {
  return client.get(`${taxBillUrl}/issue/${prjId}/${type}`);
};

export const getProjectInitBuyTaxbill = (prjId) => {
  return client.get(`${taxBillUrl}/issue/${prjId}/B`);
};

export const getProjectInitSalesTaxbill = (prjId) => {
  return client.get(`${taxBillUrl}/issue/${prjId}/S`);
};

//프로젝트별 타입별 세금계산서 발행 내역
export const getIssuedBuyTaxbills = (prjId) => {
  return client.get(`${taxBillUrl}/list/${prjId}/B`);
};
export const getIssuedSalesTaxbills = (prjId) => {
  return client.get(`${taxBillUrl}/list/${prjId}/S`);
};

// //세금 매출 취소
// export const onRemoveSales = (prjId,invUuid) => {
//   return client.delete(`${taxBillUrl}/issue/${prjId}/${invUuid}`);
// };

//프로젝트 타입별 세금계산서 발행 내역 삭제

export const removeIssuedTaxbills = (prjId, type, invId) => {
  return client.delete(`${taxBillUrl}/issue/${prjId}/${type}/${invId}`);
};

//프로젝트별 타입별 세금계산서 발행
export const addIssuedTaxbill = (prjId, dataToSubmit) => {
  return client.post(`${taxBillUrl}/issue/${prjId}`, dataToSubmit);
};

//프로젝트별 세금계산서 리스트 가져오기
export const getTaxbillsByPrj = (prjId) => {
  return client.get(`${taxBillUrl}/list/${prjId}`);
};

//세금계산서 리스트 가져오기
export const getTaxbills = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${taxBillUrl}/list?${queryString}`);
};

//세금 발행 관리
export const getTaxIssued = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${taxBillUrl}/list/request?${queryString}`);
};

//세금계산서 상세보기(id=>invUuid)
export const getTaxbill = (id) => {
  return client.get(`${taxBillUrl}/info/${id}`);
};

//세금계산서 수정
export const editTaxbill = (dataToSubmit) => {
  return client.put(`${taxBillUrl}/info/${dataToSubmit.invUuid}`, dataToSubmit);
};

//계산서 삭제(id=>invUuid)
export const removeTaxbill = (id) => {
  return client.delete(`${taxBillUrl}/info/${id}`);
};

// 세금계산서 발행 흐름(발행예정 → 발행요청 → 발행완료) - ksm_backend InvoiceController
// issue-flow 포팅 (2026-10-21). 기존 "발행" 버튼은 발행완료를 바로 찍어 발행요청 단계가
// 통째로 생략됐다(업무 흐름 점검 2 - 이슈 #4).
// 결재 사용 스위치 조회(approvalEnabled/canManage) - 환경설정 > 결재 설정 화면 +
// taxbillmng 발행요청 다이얼로그가 쓴다.
export const getIssueFlowConfig = () => {
  return client.get(`${taxBillUrl}/issue-flow/config`);
};

// 발행 요청. 여기서 비로소 발행예정이 선다(REQ_PLAN_YN='Y').
// 결재 사용 설정이 켜져 있으면 body(lineId/approverUuids)로 결재선 템플릿을 넘긴다 -
// 세금계산서 발행 요청 결재(스위치), 2026-10-21.
export const requestIssue = (invUuid, body) => {
  return client.put(`${taxBillUrl}/${invUuid}/issue-request`, body || {});
};

// 발행 완료(REQ_COMP_YN='Y'). 결재를 쓰는 설정이면 승인 전까지(잠금 해제 전까지) 서버가 막는다.
export const completeIssue = (invUuid) => {
  return client.put(`${taxBillUrl}/${invUuid}/issue-complete`);
};

// 결재 사용 스위치 토글 - 관리자 전용(서버에서 다시 확인한다).
export const putIssueFlowConfig = (enabled) => {
  return client.put(`${taxBillUrl}/issue-flow/config`, { enabled });
};

// 이 회차의 발행 요청 결재(V2) 문서 조회 - 결재가 없으면 info=null.
export const getIssueApproval = (invUuid) => {
  return client.get(`${taxBillUrl}/${invUuid}/issue-approval`);
};
